import moment from 'moment';
import { QRCodeRoaming } from '../constants';

const initialState = {
  dataQueryTransactionInfo: JSON.parse(sessionStorage.getItem('dataQueryTransactionInfo')) || null,
};

export function qrCodeReducer(state = initialState, action) {
  switch (action.type) {
    case QRCodeRoaming.SET_DATA_QUERY_TRANSACTION_INFO:
      sessionStorage.setItem('dataQueryTransactionInfo', JSON.stringify(action.payload));
      return {
        ...state,
        dataQueryTransactionInfo: action.payload
      };
    default:
      return state;
  }
};
